import { AdFormValues } from 'hooks/useFormUtils';

export const NUM_MAX_CALLOUT_EXTENSIONS_BING = 4;
export const NUM_MAX_LOCATION_EXTENSIONS_BING = 1;
export const NUM_MAX_SITELINK_EXTENSIONS_BING = 6;
export const NUM_MAX_SNIPPET_EXTENSIONS_BING = 3;
export const NUM_MAX_SNIPPET_EXTENSIONS_BING_TEXT = 3;

// Defines the form values for the BingAdForm
export interface BingAdFormValues extends AdFormValues {
  headline1: string;
  headline2: string;
  headline3: string;
  description: string;
  description2: string;
  destinationUrl: string;
}
